import React, { useEffect, useState, useCallback } from "react";
import {
  FaPlus,
  FaEllipsisVertical,
  FaEye,
  FaPen,
  FaFilter,
  FaPaste,
} from "react-icons/fa6";
import { MdDelete, MdClose } from "react-icons/md";
import moment from "moment";
import Tooltip from "react-tooltip";
import { Header, DataTable } from "../../../common";
import { COMMON_STOP_WORDS } from "../../../../constants/constants";
//
import { YouTubeChannelsList, YouTubePick } from "./Components";
import { youtubeUrlConstants } from "../../../../store/YouTubeManagement/YouTubeManagementReducer";

import {
  ButtonView,
  CardView,
  Input,
  Select,
  ModalView,
  IconMenuOption,
  TagView,
} from "../../../controls";
import { MdSearch } from "react-icons/md";
import { Role } from "../../../../constants/role";
import Nav from "react-bootstrap/Nav";
//
import "./YouTubeManagementStyles.scss";
import { history } from "../../../../store/configure/configureStore";

const YouTubeManagementView = ({
  unblock,
  //
  fields,
  genreWithVideoId,
  categoryWithVideoId,
  multipleVideoIds,
  youtubeList,
  showRowsPerPage,
  showMenuOptions,
  showSelection,
  errors,
  activeNavTab,
  //
  currentPage,
  rowsPerPage,
  //
  handleTableRowsChange,
  handleChangePage,
  handleShowMenuOptions,
  handleCloseMenuOptions,
  handleInitialGenresOfRow,
  handleRemoveGenres,
  handleRemoveNewlyAddedGenres,
  handleOnClickReset,
  //
  onChangeSearchInput,
  onClickSearch,
  //
  rowsPerPageDropDownOptions,
  tagDropDownOptions,
  categoryDropDownOptions,
  //
  handleSelectedRows,
  selectableRowSelectedOnGenreChange,
  setNavigatingToOtherTabWarningModal,
  handleShowSelection,
  handleCloseSelection,
  handleBulkPublishVideos,
  onChangeVideoUrlInput,
  onChangeGenres,
  onChangeCategory,
  //
  handlePaste,
  handleClear,
  onClickVideoGenreAdd,
  onClickVideoCategoryAdd,
  handleTabChange,
  handleUploadVideoByUrl,
  //
  status,
  languages,
  youTubeSourceList,
  //
  onClickStatusDropDownFilterOptions,
  onClickLanguageDropDownFilterOptions,
  onClickChannelNameDropDownFilterOptions,
  //
  userRole,
  userPermissions,
  //
  persistedData,
  onTabChangeSaveAsDraft,
  onClickSaveASDraftDiscard,
  //
  showModal,
  showWarningPopup,
  showUploadUrlPopup,
  showAddGenrePopup,
  showAddCategoryPopup,
  showTabChangePopup,
  showWarningPopupForRowGenresOnNavChange,
  showWarningForCategorySelection,
  handleCloseModal,
  //
  resetRowTags,
  resetRowCategory,
  resetNavigatingToOtherPageWarningModal,
  resetSelectedMultipleRows,
  selectedMultipleRowVideo,
  //
  redirectingLink,
  setNavigatingToOtherPageWarningModal,
  redirectingTab,
}) => {
  // console.log("multipleVideoIds", multipleVideoIds);
  // console.log("genreWithVideoId", genreWithVideoId);
  const [selectionOfRows, setSelectionOfRows] = useState(false);
  const [rowData, setRowData] = useState("");
  const [rowId, setRowId] = useState("");
  //
  const [genreValues, setGenreValue] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [activeTabNav, setActiveTabNav] = useState(
    redirectingTab ? redirectingTab : activeNavTab
  );

  const viewer = userRole === Role.Viewer;

  const isChannelNameOmitted =
    activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;

  //--------------------------action UI

  const handleOnRowClicked = (row) => {
    const rowGenresAreUpdated = genreWithVideoId.some(
      (item) =>
        item.hasOwnProperty("updatedGenre") ||
        item.hasOwnProperty("removedGenre")
    );
    setRowId(row._id);

    const savedRowsInRedux = selectedMultipleRowVideo
      ?.map((item) => item?.selectedRows)
      ?.flat();

    // (multipleVideoIds?.length > 0 &&
    //   selectedMultipleRowVideo.length !== multipleVideoIds?.length) ||
    // (multipleVideoIds?.length === 0 &&
    //   selectedMultipleRowVideo.length !== multipleVideoIds?.length)
    //   ? showWarningPopupForRowGenresOnNavChange()
    //   : history.push(
    //       `/media/content-detail/youtube/${row._id}?page=${currentPage}&limit=${rowsPerPage?.value}`
    //     );

    (multipleVideoIds?.length > 0 &&
      savedRowsInRedux?.length !== multipleVideoIds?.length) ||
    (multipleVideoIds?.length === 0 &&
      savedRowsInRedux?.length !== multipleVideoIds?.length)
      ? showWarningPopupForRowGenresOnNavChange()
      : history.push(
          `/media/content-detail/youtube/${row._id}?page=${currentPage}&limit=${rowsPerPage?.value}`
        );
  };

  //--------------------------Selection Warning modal UI
  const renderSelectionWarningBody = () => {
    return (
      <div className="body-content-wrapper warning-body">
        <div>Please select the videos to publish</div>
      </div>
    );
  };

  const selectionWarningFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Ok"
            styles={"secondary"}
            // styles={"light"}
            size={"medium"}
            onClick={handleCloseModal}
          />
        </div>
      </div>
    );
  };
  //--------------------------Upload Youtube video Modal
  const renderUploadYoutubeVideoBody = () => {
    return (
      <div className="body-content-wrapper upload-url-body">
        <div className="url-wrapper">
          <Input
            name={"videoUrl"}
            label={"YouTube URL"}
            isrequired={true}
            placeholder={"Please enter url"}
            value={fields?.videoUrl}
            // showPasteIcon={true}
            // handlePaste={() => handlePaste()}
            onChange={(e) => onChangeVideoUrlInput(e)}
            error={errors["videoUrl"]}
            autocomplete="off"
          />
        </div>
        <div className="action-block ">
          <ButtonView
            title="Paste"
            styles={"secondary dark-btn"}
            onClick={() => handlePaste()}
            icon={<FaPaste />}
          />
        </div>
      </div>
    );
  };

  const uploadYoutubeVideoFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Upload"
            styles={"secondary"}
            // styles={"light"}
            size={"medium"}
            onClick={handleUploadVideoByUrl}
          />
        </div>
      </div>
    );
  };

  //--------------------------show Warning modal when navigation to different page using sidebar
  const renderNavigatingToOtherPageWarningBody = () => {
    return (
      <div className="body-content-wrapper warning-body">
        <div>
          All the selections and updated genres for the YouTube video will be
          lost.
        </div>
      </div>
    );
  };

  const renderNavigatingToOtherPageWarningFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Proceed"
            styles={"secondary"}
            // styles={"light"}
            size={"medium"}
            onClick={() => {
              if (redirectingTab) {
                //when tab change call then api to get data
                setActiveTabNav(redirectingTab);
                const videosByDailyCronType =
                  youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON;
                const videosByUrlType =
                  youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;
                if (
                  redirectingTab ===
                  youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON
                ) {
                  handleTabChange(
                    videosByDailyCronType,
                    youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON
                  );
                } else {
                  handleTabChange(
                    videosByUrlType,
                    youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL
                  );
                }
                handleCloseSelection();
                resetRowTags();
                resetRowCategory();
                resetNavigatingToOtherPageWarningModal();
                resetSelectedMultipleRows(); //reset the redux state of selected rows
                handleOnClickReset();
              } else {
                unblock(); //unblock the navigation
                // console.log("redirecting link", redirectingLink);
                history.push(redirectingLink);
                handleCloseSelection();
                resetRowTags();
                resetRowCategory();
                resetNavigatingToOtherPageWarningModal();
                resetSelectedMultipleRows(); //reset the redux state of selected rows
                handleOnClickReset();
              }

              resetNavigatingToOtherPageWarningModal();
            }}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Cancel"
            styles={"light"}
            // styles={"light"}
            size={"medium"}
            onClick={() => {
              handleCloseModal();
              resetNavigatingToOtherPageWarningModal();
            }}
          />
        </div>
      </div>
    );
  };

  //--------------------------show Warning modal when tab change or page change

  const renderNavigatingToOtherTabWarningBody = () => {
    return (
      <div className="body-content-wrapper warning-body">
        <div>
          All the selections and updated genres for the YouTube video will be
          lost.
        </div>
      </div>
    );
  };

  const renderNavigatingToOtherTabWarningFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Proceed"
            styles={"secondary"}
            // styles={"light"}
            size={"medium"}
            onClick={() => {
              if (redirectingTab) {
                //when tab change call then api to get data
                setActiveTabNav(redirectingTab);
                const videosByDailyCronType =
                  youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON;
                const videosByUrlType =
                  youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;
                if (
                  redirectingTab ===
                  youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON
                ) {
                  handleTabChange(
                    videosByDailyCronType,
                    youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON
                  );
                } else {
                  handleTabChange(
                    videosByUrlType,
                    youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL
                  );
                }
                handleCloseSelection();
                resetRowTags();
                resetRowCategory();
                resetNavigatingToOtherPageWarningModal();
                resetSelectedMultipleRows(); //reset the redux state of selected rows
                handleOnClickReset();
                handleCloseModal();
              } else {
                // unblock(); //unblock the navigation
                // // console.log("redirecting link", redirectingLink);
                // history.push(redirectingLink);
                // handleCloseSelection();
                // resetRowTags();
                //resetRowCategory()
                // resetNavigatingToOtherPageWarningModal();
                // resetSelectedMultipleRows(); //reset the redux state of selected rows
                // handleOnClickReset();
              }

              resetNavigatingToOtherPageWarningModal();
            }}
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Cancel"
            styles={"light"}
            // styles={"light"}
            size={"medium"}
            onClick={() => {
              handleCloseModal();
              // resetNavigatingToOtherPageWarningModal();
            }}
          />
        </div>
      </div>
    );
  };

  //--------------------------save row genre warning Modal
  const renderRowGenreWarningBody = () => {
    return (
      <div className="body-content-wrapper warning-body">
        <div>
          Do you want to save the selected YouTube videos before proceeding?
        </div>
      </div>
    );
  };

  const renderRowGenreWarningFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Discard"
            styles={"danger"}
            // styles={"light"}
            size={"medium"}
            onClick={() =>
              onClickSaveASDraftDiscard(() =>
                history.push(
                  `/media/content-detail/youtube/${rowId}?page=${currentPage}&limit=${rowsPerPage?.value}`
                )
              )
            }
          />
        </div>
        <div className="action-wrapper">
          <ButtonView
            title="Save"
            styles={"secondary"}
            // styles={"light"}
            size={"medium"}
            onClick={() =>
              onTabChangeSaveAsDraft(() =>
                history.push(
                  `/media/content-detail/youtube/${rowId}?page=${currentPage}&limit=${rowsPerPage?.value}`
                )
              )
            }
          />
        </div>
      </div>
    );
  };

  //--------------------------select Category warning Modal
  const renderCategorySelectionWarningBody = () => {
    return (
      <div className="body-content-wrapper warning-body">
        <div>
          Please select the categories for the selected videos before publishing
        </div>
      </div>
    );
  };

  const renderCategorySelectionWarningFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Close"
            styles={"secondary"}
            // styles={"light"}
            size={"medium"}
            onClick={() => {
              handleCloseModal();
            }}
          />
        </div>
      </div>
    );
  };

  //--------------------------Add genre Modal

  const createOption = (label) => ({
    label,
    value: label,
    __isNew__: true,
  });

  const capitalizeWords = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
        event.preventDefault();
        break;
      case "Tab":
      case ",":
        const capitalizedInput = capitalizeWords(inputValue.trim());
        // Check if the capitalizedInput already exists in the genreValues or genres arrays
        const isDuplicateInGenreValue = genreValues.some(
          (option) =>
            option.label.toLowerCase() === capitalizedInput.toLowerCase()
        );

        const filteredObject = genreWithVideoId?.filter(
          (item) => item?.objectId === rowData?._id
        );
        const genres = filteredObject?.[0]?.genres;

        //check if genre with same label exist in saved video genre
        const isDuplicateInGenres = genres.some(
          (genre) => genre.toLowerCase() === capitalizedInput.toLowerCase()
        );

        if (
          !isDuplicateInGenreValue &&
          !isDuplicateInGenres &&
          inputValue !== ","
        ) {
          setGenreValue((prev) => [...prev, createOption(capitalizedInput)]);
          setInputValue("");
        }
        // setGenreValue((prev) => [...prev, createOption(capitalizedInput)]);
        // setInputValue("");
        // console.log("tagvlaue key down", genreValues);
        event.preventDefault();
    }
  };

  const onRemoveItem = (action) => {
    if (action.action === "remove-value" || action.action === "pop-value") {
      const updatedGenres = genreValues.filter(
        (item) => item.label !== action.removedValue.label
      );
      setGenreValue(updatedGenres);
      console.log("remove", updatedGenres);
      console.log("genreWithVideoId", genreWithVideoId);

      // Update savedGenres by removing the label from it
      handleRemoveNewlyAddedGenres(rowData, action);
    }

    if (action.action === "clear") {
      setGenreValue([]);
    }
  };

  const isValidNewOption = (inputValue) => {
    const filteredObject = genreWithVideoId?.filter(
      (item) => item?.objectId === rowData?._id
    );
    const genres = filteredObject?.[0]?.genres || [];

    const savedGenres = genres; // existing genres of the video
    const GenreValueLabels = genreValues?.map((item) => item.label);
    const newGenres = GenreValueLabels; // new genres
    const mergedGenres = [...savedGenres, ...newGenres];

    // Normalize inputValue to lowercase for comparison
    const normalizedInputValue = inputValue.toLowerCase().trim();

    // Create a set of lowercase labels from mergedGenres for efficient lookup
    const youtubeGenreLabels = new Set(
      mergedGenres.map((genre) => genre.toLowerCase())
    );

    // Create a set of stop words for efficient lookup
    const stopWordsSet = new Set(COMMON_STOP_WORDS);

    // Check if inputValue exists in the stop words list
    if (stopWordsSet.has(normalizedInputValue)) {
      return false; // Disable creating new option if it matches a stop word
    }

    // Check if inputValue already exists in mergedGenres
    if (youtubeGenreLabels.has(normalizedInputValue)) {
      return false; // Disable creating new option if it already exists
    }

    // Allow creating new options for other values
    if (!youtubeGenreLabels.has(normalizedInputValue) && inputValue !== "") {
      return true;
    }
  };

  const renderSavedGenreList = () => {
    // console.log("rowData.tag", rowData.tag);
    // console.log("rowData", rowData.subCategory);

    // console.log("genreWithVideoId", genreWithVideoId);
    const filteredObject = genreWithVideoId?.filter(
      (item) => item?.objectId === rowData?._id
    );

    // console.log("filteredObject", filteredObject);
    // const savedGenres = filteredObject?.[0]?.genres;

    //render genres which are in rowData.
    // const savedGenres = filteredObject?.[0]?.genres?.filter((item) =>
    //   rowData?.subCategory?.some((rowTag) => rowTag?.tag === item)
    // );
    // console.log("saved render", savedGenres);

    // Extract the filtered genres
    const filteredGenres =
      filteredObject?.[0]?.genres?.filter((item) =>
        rowData?.subCategory?.some((rowTag) => rowTag?.tag === item)
      ) || [];

    // Extract all rowTags from rowData
    const rowTags = rowData?.subCategory?.map((rowTag) => rowTag?.tag) || [];

    //if genre is removed then show filteredGenres only
    const updatedGenres = filteredObject?.[0]?.removedGenre
      ? filteredGenres
      : [...new Set([...filteredGenres, ...rowTags])];

    // Combine filtered genres and rowTags, ensuring uniqueness
    // const savedGenres = [...new Set([...filteredGenres, ...rowTags])];
    const savedGenres = updatedGenres;
    console.log("savedGenres", savedGenres);
    console.log("rowData", rowData);
    console.log("filteredGenres", filteredGenres);

    return (
      <>
        {savedGenres?.length !== 0 && (
          <div className={`tag-list-content-wrapper`}>
            {savedGenres?.map((item, index) => (
              <span className="tag-content">
                <span className="content">
                  {/* {item.label ? item.label : item.tag} */}
                  {item?.label ? item?.label : item}
                </span>
                <span className="ms-1">
                  {userPermissions?.includes("manage_tag") && (
                    <MdClose
                      onClick={() => {
                        handleRemoveGenres(index, rowData);
                        console.log(index);
                      }}
                    />
                  )}
                </span>
              </span>
            ))}
          </div>
        )}
      </>
    );
  };

  // const renderSavedGenreList = () => {
  //   console.log("rowData", rowData.subCategory);
  //   console.log("genreWithVideoId", genreWithVideoId);

  //   const filteredObject = genreWithVideoId?.filter(
  //     (item) => item?.objectId === rowData?._id
  //   );

  //   console.log("filteredObject", filteredObject);

  //   const savedGenres = filteredObject?.[0]?.genres?.filter((item) =>
  //     rowData?.subCategory?.some((rowTag) => rowTag?.tag === item)
  //   );

  //   // Safely access subCategory and map its tags
  //   const subCategoryTags = rowData?.subCategory?.map((sub) => sub?.tag) || [];

  //   // Merge subCategoryTags and savedGenres
  //   const mergedGenres = [
  //     ...new Set([
  //       ...subCategoryTags, // Add tags from subCategory
  //       ...(savedGenres || []), // Add savedGenres if they exist
  //     ]),
  //   ];

  //   return (
  //     <div className={`tag-list-content-wrapper`}>
  //       {mergedGenres.map((item, index) => (
  //         <span className="tag-content" key={index}>
  //           <span className="content">{item?.label ? item?.label : item}</span>
  //           <span className="ms-1">
  //             {userPermissions?.includes("manage_tag") && (
  //               <MdClose
  //                 onClick={() => {
  //                   handleRemoveGenres(index, rowData);
  //                   console.log(index);
  //                 }}
  //               />
  //             )}
  //           </span>
  //         </span>
  //       ))}
  //     </div>
  //   );
  // };

  useEffect(() => {
    if (showModal.showAddGenreModal === false) {
      setGenreValue([]);
    }
  }, [showModal.showAddGenreModal]);

  const renderValuesInsideTagInputField = () => {
    const filteredObject = genreWithVideoId?.filter(
      (item) => item?.objectId === rowData?._id
    );

    const savedGenres = filteredObject?.[0]?.genres;
    // this is to save newly added genres in input field rather than below the input field
    const filterTagValues = savedGenres?.filter(
      (item) => !rowData?.subCategory?.some((tagObj) => tagObj.tag === item)
    );

    console.log("render input", savedGenres);
    console.log("rowData input", rowData);

    // console.log("filterTagValues", filterTagValues);

    const genreObjectsArray =
      filterTagValues?.map((value) => ({
        label: value,
        value: value,
      })) || [];

    const mergedTagValues = [...genreObjectsArray, ...genreValues];

    setGenreValue(mergedTagValues);
  };

  useEffect(() => {
    if (showModal.showAddGenreModal === true) {
      renderValuesInsideTagInputField();
    }
  }, [showModal.showAddGenreModal]);

  const renderVideoGenreBody = () => {
    //tag modal body
    const filteredObject = genreWithVideoId?.filter(
      (item) => item?.objectId === rowData?._id
    );

    const savedGenres = filteredObject?.[0]?.genres;

    //filter out the genres which are already present in rowdata
    const filteredTagDropDownOptions = tagDropDownOptions?.filter(
      (item) => !savedGenres?.includes(item?.label)
    );

    return (
      <div className="body-content-wrapper">
        <div className="video-tag-body">
          <div className="url-wrapper">
            <TagView
              name="genre"
              classNamePrefix={genreValues?.length > 0 ? "tag-menu-active" : ""}
              label={"Genre"}
              value={genreValues}
              isrequired={true}
              isMulti={true}
              isSearchable={true}
              placeholder={"Please add genre"}
              options={filteredTagDropDownOptions}
              // options={tagDropDownOptions}
              handleKeyDown={handleKeyDown}
              inputValue={inputValue}
              onInputChange={(newValue) => {
                setInputValue(newValue);
                // console.log("oninput valuechgne", newValue);
              }}
              onChange={(val, action) => {
                onChangeGenres(val);
                setGenreValue([...genreValues, val.slice(-1)[0]]);
                onRemoveItem(action);
              }}
              isValidNewOption={isValidNewOption}
              error={errors["genre"]}
            />
          </div>
          {/* <div className="action-block ">
            <ButtonView
              title="Add"
              styles={"secondary"}
              // styles={"secondary dark-btn"}
              onClick={() => onClickVideoGenreAdd(rowData, genreValues)} //row is passed to identify the row
              // icon={<FaPaste />}
            />
          </div> */}
        </div>
        <div>{renderSavedGenreList()}</div>
      </div>
    );
  };

  const genreFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Save"
            styles={"secondary"}
            // styles={"secondary dark-btn"}
            onClick={() => onClickVideoGenreAdd(rowData, genreValues)} //row is passed to identify the row
            // icon={<FaPaste />}
          />
        </div>
      </div>
    );
  };

  // const [placeholderValue, setPlaceholderValue] = useState({
  //   value: "",
  //   label: "",
  // });
  // const [isManuallyUpdated, setIsManuallyUpdated] = useState(false);

  // Use useEffect to compute placeholderValue when rowData or categoryWithVideoId changes
  // useEffect(() => {
  //   if (isManuallyUpdated) return; // Skip recomputing if the user has manually selected a value

  //   const extractedCategoryObject = categoryWithVideoId?.find(
  //     (item) => item?.objectId === rowData?._id
  //   );

  //   const filteredOptions = extractedCategoryObject
  //     ? categoryDropDownOptions?.filter(
  //         (item) => item?.label === extractedCategoryObject?.category?.label
  //       )
  //     : null;

  //   const defaultPlaceHolderValue =
  //     filteredOptions?.length > 0
  //       ? filteredOptions[0]
  //       : categoryDropDownOptions?.find(
  //           (item) => item?.label === rowData?.categoryId?.categoryName
  //         ) || null;

  //   setPlaceholderValue(defaultPlaceHolderValue);
  // }, [
  //   rowData,
  //   categoryWithVideoId,
  //   categoryDropDownOptions,
  //   isManuallyUpdated,
  // ]);

  //-----------------video category modal
  const renderVideoCategoryBody = () => {
    return (
      <div className="body-content-wrapper">
        <div className="video-tag-body">
          <div className="url-wrapper">
            <Select
              // value={placeholderValue}
              label={"Category"}
              placeholder={"Please add category"}
              options={categoryDropDownOptions}
              onChange={(val) => {
                // setPlaceholderValue(val);
                // setIsManuallyUpdated(true); // Prevent `useEffect` from overwriting
                onChangeCategory(val);
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  const categoryFooter = () => {
    return (
      <div className="footer-wrapper">
        <div className="action-wrapper">
          <ButtonView
            title="Save"
            styles={"secondary"}
            onClick={() => {
              onClickVideoCategoryAdd(rowData);
              // setIsManuallyUpdated(false);
            }} //row is passed to identify the row
          />
        </div>
      </div>
    );
  };

  const bulkPublishActionComponent = () => {
    return (
      <div className="action-btn-wrapper">
        {userPermissions?.includes("bulk_video_published") &&
        showSelection === false ? (
          <ButtonView
            title="Publish In Bulk"
            styles={"secondary"}
            extraStyles={"extra-btn-styles"}
            onClick={() => handleShowSelection()}
            // icon={<FaPlus />}
          />
        ) : (
          userPermissions?.includes("bulk_video_published") && (
            <ButtonView
              title="Publish"
              styles={"secondary btn"}
              onClick={() => {
                handleBulkPublishVideos(() => {
                  resetSelectedMultipleRows();
                  resetRowCategory();
                });
                // handleCloseSelection();
              }}
              // icon={<FaPlus />}
            />
          )
        )}
        {showSelection === true && (
          <ButtonView
            title="Reset"
            styles={"light btn"}
            onClick={() => {
              handleCloseSelection();
              resetRowTags();
              resetRowCategory();
              resetNavigatingToOtherPageWarningModal();
              resetSelectedMultipleRows(); //reset the redux state of selected rows
              handleOnClickReset(); //reset the state
            }}
            // icon={<FaPlus />}
          />
        )}
        {userPermissions?.includes("add_youtube_video") &&
          activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL &&
          !showSelection && (
            <ButtonView
              title="Upload Video"
              styles={"secondary"}
              onClick={() => showUploadUrlPopup()}
              // icon={<FaPlus />}
            />
          )}
      </div>
    );
  };

  //--------------------------Custom Table Styles

  const customStyles = {
    cells: {
      style: {
        width: "100px",
      },
    },
  };

  //--------------------------extract row ids from genreWithVideoId
  const rowObjectIds = genreWithVideoId?.map((item) => item?.objectId);

  // function areArraysEqual(array1, array2) {
  //   // Sort both arrays
  //   const sortedArray1 = array1.slice().sort();
  //   const sortedArray2 = array2.slice().sort();

  //   // Check if they have the same length and elements
  //   return (
  //     sortedArray1.length === sortedArray2.length &&
  //     sortedArray1.every((value, index) => value === sortedArray2[index])
  //   );
  // }

  function areArraysEqual(array1, array2) {
    if (!Array.isArray(array1) || !Array.isArray(array2)) {
      // Return false or handle the error as needed
      return false;
    }

    // Sort both arrays
    const sortedArray1 = array1.slice().sort();
    const sortedArray2 = array2.slice().sort();

    // Check if they have the same length and elements
    return (
      sortedArray1.length === sortedArray2.length &&
      sortedArray1.every((value, index) => value === sortedArray2[index])
    );
  }

  const conditionalRowStyles = [
    {
      when: (row) => {
        // Extract genres from the row
        // const rowTags = row?.subCategory?.map((item) => item.tag) || [];
        const rowTags = Array.isArray(row?.subCategory)
          ? row?.subCategory?.map((item) => item?.tag || null)
          : [];

        // Extract genres from genreWithVideoId and flatten the array
        const extractedTagsFromTagsWithVideoId =
          genreWithVideoId
            ?.filter((item) => item.objectId === row?._id) // Assuming you want to match based on row._id
            ?.flatMap((item) => item.genres) || [];

        // Compare the genres arrays
        const areTagsEqual = areArraysEqual(
          rowTags,
          extractedTagsFromTagsWithVideoId
        );

        //
        const extractedCategoryObject = categoryWithVideoId?.find(
          (item) => item?.objectId === row?._id
        );

        const isCategoriesAreNotSameInRowAndExtractedCategoryObject =
          extractedCategoryObject &&
          row?.categoryId?.categoryName !==
            extractedCategoryObject?.category?.label;

        // Apply style if row._id is in rowObjectIds and genres are not equal
        return (
          (rowObjectIds?.includes(row?._id) && !areTagsEqual) ||
          isCategoriesAreNotSameInRowAndExtractedCategoryObject
        );
      },
      style: {
        // backgroundColor: "lightgray",
        backgroundColor: "#f9beb2",
        "&:hover": {
          backgroundColor: "#f9beb2",
        },
      },
    },
  ];

  //--------------------------Tab UI
  function navigationTabs() {
    const videosByDailyCronType =
      youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON;
    const videosByUrlType = youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL;

    const handleSelect = (selectedKey) => {
      if (showSelection) {
        setNavigatingToOtherTabWarningModal(selectedKey); // Show warning modal
        showTabChangePopup();
      } else {
        setActiveTabNav(selectedKey); // Update active tab
      }
    };

    return (
      <Nav
        className={"tab-navigation-wrapper"}
        variant="tabs"
        activeKey={
          activeTabNav
            ? activeTabNav
            : youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON
        }
        onSelect={(selectedKey) => handleSelect(selectedKey)} // Handle tab selection manually
      >
        <Nav.Item className="nav-item">
          <Nav.Link
            className="text-bold"
            eventKey={youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON}
            onClick={(e) => {
              if (!showSelection) {
                e.preventDefault();
                handleTabChange(
                  videosByDailyCronType,
                  youtubeUrlConstants.YOUTUBE_VIDEOS_BY_DAILY_CRON
                );
              }
            }}
          >
            YouTube Channels
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            eventKey={youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL}
            onClick={(e) => {
              if (!showSelection) {
                e.preventDefault();
                handleTabChange(
                  videosByUrlType,
                  youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL
                );
              }
            }}
          >
            YouTube Picks
          </Nav.Link>
        </Nav.Item>
      </Nav>
    );
  }

  // avoid rerendering using useCallback hook
  // const memoizedHandleSelectedRows = useCallback(
  //   ({ selectedRows }) => {
  //     // console.log("selectedRows", selectedRows);
  //     if (
  //       //only run when multipleVideoIds and selectedRows are available
  //       (selectedRows.length === 0 && multipleVideoIds.length > 0) ||
  //       selectedRows.length > 0
  //     ) {
  //       handleSelectedRows(selectedRows);
  //     }
  //   },
  //   [handleSelectedRows, multipleVideoIds]
  // );

  const memoizedHandleSelectedRows = useCallback(
    ({ selectedRows }) => {
      // console.log("selectedRows", selectedRows);
      // // Check if the page was refreshed
      const isRefreshed = sessionStorage.getItem("isRefreshed");
      if (
        //only run when multipleVideoIds and selectedRows are available
        // (selectedRows.length === 0 && multipleVideoIds.length > 0) ||
        // selectedRows.length > 0
        (!isRefreshed || isRefreshed === "false") &&
        // Additional conditions based on selectedRows and multipleVideoIds
        ((selectedRows.length === 0 && multipleVideoIds.length > 0) ||
          selectedRows.length > 0)
      ) {
        // console.log("selectedRows", selectedRows);
        handleSelectedRows(selectedRows);
      }
    },
    [handleSelectedRows, multipleVideoIds]
  );

  //--------------------------Tables

  const YouTubePickComponent = (
    <YouTubePick
      youtubeList={youtubeList}
      rowObjectIds={rowObjectIds}
      multipleVideoIds={multipleVideoIds}
      //
      youTubeSourceList={youTubeSourceList}
      onClickChannelNameDropDownFilterOptions={
        onClickChannelNameDropDownFilterOptions
      }
      persistedData={persistedData}
      languages={languages}
      onClickLanguageDropDownFilterOptions={
        onClickLanguageDropDownFilterOptions
      }
      onChangeCategory={onChangeCategory}
      onClickVideoCategoryAdd={onClickVideoCategoryAdd}
      userRole={userRole}
      Role={Role}
      status={status}
      categoryDropDownOptions={categoryDropDownOptions}
      onClickStatusDropDownFilterOptions={onClickStatusDropDownFilterOptions}
      showSelection={showSelection}
      isChannelNameOmitted={isChannelNameOmitted}
      setRowData={setRowData}
      handleInitialGenresOfRow={handleInitialGenresOfRow}
      showAddGenrePopup={showAddGenrePopup}
      showAddCategoryPopup={showAddCategoryPopup}
      viewer={viewer}
      genreWithVideoId={genreWithVideoId}
      categoryWithVideoId={categoryWithVideoId}
      bulkPublishActionComponent={bulkPublishActionComponent}
      handleOnRowClicked={handleOnRowClicked}
      handleSelectedRows={memoizedHandleSelectedRows}
      selectableRowSelectedOnGenreChange={selectableRowSelectedOnGenreChange}
      handleTableRowsChange={handleTableRowsChange}
      handleChangePage={handleChangePage}
      currentPage={currentPage}
      customStyles={customStyles}
      conditionalRowStyles={conditionalRowStyles}
    />
  );

  console.log("errors", errors);

  const YouTubeChannelsListComponent = (
    <YouTubeChannelsList
      youtubeList={youtubeList}
      multipleVideoIds={multipleVideoIds}
      //
      youTubeSourceList={youTubeSourceList}
      onClickChannelNameDropDownFilterOptions={
        onClickChannelNameDropDownFilterOptions
      }
      persistedData={persistedData}
      languages={languages}
      onClickLanguageDropDownFilterOptions={
        onClickLanguageDropDownFilterOptions
      }
      onChangeCategory={onChangeCategory}
      onClickVideoCategoryAdd={onClickVideoCategoryAdd}
      userRole={userRole}
      Role={Role}
      status={status}
      categoryDropDownOptions={categoryDropDownOptions}
      onClickStatusDropDownFilterOptions={onClickStatusDropDownFilterOptions}
      showSelection={showSelection}
      isChannelNameOmitted={isChannelNameOmitted}
      setRowData={setRowData}
      handleInitialGenresOfRow={handleInitialGenresOfRow}
      showAddGenrePopup={showAddGenrePopup}
      showAddCategoryPopup={showAddCategoryPopup}
      viewer={viewer}
      genreWithVideoId={genreWithVideoId}
      categoryWithVideoId={categoryWithVideoId}
      bulkPublishActionComponent={bulkPublishActionComponent}
      handleOnRowClicked={handleOnRowClicked}
      handleSelectedRows={memoizedHandleSelectedRows}
      selectableRowSelectedOnGenreChange={selectableRowSelectedOnGenreChange}
      handleTableRowsChange={handleTableRowsChange}
      handleChangePage={handleChangePage}
      currentPage={currentPage}
      customStyles={customStyles}
      conditionalRowStyles={conditionalRowStyles}
    />
  );

  // console.log("active tab", activeNavTab);

  // const searchFieldName =
  //   activeNavTab === "videosByDailyCron"
  //     ? "searchValue"
  //     : "searchValueForYoutubePick";

  const searchFieldName =
    activeNavTab === "videosByDailyCron" ? "titleSearch" : "titleSearchByUrl";

  const renderList = () => {
    const searchValue =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL
        ? fields?.searchValueVideosByUrl?.titleSearchByUrl
        : fields?.searchValue?.titleSearch;

    const activeNavTable =
      activeNavTab === youtubeUrlConstants.YOUTUBE_VIDEOS_BY_URL
        ? YouTubePickComponent
        : YouTubeChannelsListComponent;
    return (
      <div className="youtube__management--table-wrapper">
        <div className="controls-wrapper">
          <div className="row-control-wrapper">
            <Select
              value={rowsPerPage}
              placeholder={"10"}
              options={rowsPerPageDropDownOptions}
              onChange={(val) => handleTableRowsChange(val)}
              isRowCap={true}
            />
            entries per page
          </div>
          {!showSelection && (
            <div className="row-control-wrapper">
              Search:{" "}
              <Input
                name={searchFieldName}
                isrequired={true}
                value={searchValue}
                placeholder={"Type here to search"}
                onChange={(e) => onChangeSearchInput(e)}
                showClearIcon={searchValue ? true : false}
                handleClear={handleClear}
                error={errors[searchFieldName]}
                isSearchInput={true}
                autocomplete="off"
              />
              <div className="search-action-wrapper">
                <ButtonView
                  // title="Search"
                  icon={<MdSearch size={20} color="#eca55a" />}
                  styles={"secondary"}
                  size={"medium btn"}
                  onClick={() => onClickSearch()}
                />
              </div>
            </div>
          )}
        </div>
        <div className="table-content">{activeNavTable}</div>
      </div>
    );
  };

  return (
    <div className="youtube__management--container">
      <div className="youtube__management--header-wrapper">
        <div className="title-content">YouTube Management</div>
      </div>
      <div className="youtube__management--navigationTab">
        {navigationTabs()}
      </div>
      {renderList()}

      <ModalView
        show={showModal.showWarningModal}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={true}
        title={"Selection Required*"}
        size={"md"}
        children={renderSelectionWarningBody()}
        footer={selectionWarningFooter()}
      />
      <ModalView
        show={showModal.showUploadVideoModal}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={true}
        title={"Upload YouTube Video"}
        size={"md"}
        children={renderUploadYoutubeVideoBody()}
        footer={uploadYoutubeVideoFooter()}
      />
      <ModalView
        show={showModal.showAddGenreModal}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={true}
        title={"Add Video Genre"}
        modalHeaderStyles={"modalHeaderStyles-tag-modal"}
        size={"md"}
        children={renderVideoGenreBody()}
        footer={genreFooter()}
      />
      <ModalView
        show={showModal.showAddCategoryModal}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={true}
        title={"Add Video Category"}
        modalHeaderStyles={"modalHeaderStyles-tag-modal"}
        size={"md"}
        children={renderVideoCategoryBody()}
        footer={categoryFooter()}
      />
      <ModalView
        show={showModal.showWarningForRowGenres}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={true}
        title={"Attention"}
        size={"md"}
        children={renderRowGenreWarningBody()}
        footer={renderRowGenreWarningFooter()}
      />
      {/* <ModalView
        show={showModal.showWarningForRowTagsWhenNavigating}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={true}
        title={"Attention"}
        size={"md"}
        children={renderNavigatingToOtherPageWarningBody()}
        footer={renderNavigatingToOtherPageWarningFooter()}
      /> */}
      <ModalView
        show={showModal.showWarningForRowTagsWhenNavigatingToOtherTab}
        handleClose={handleCloseModal}
        center={true}
        showCloseIcon={true}
        title={"Attention"}
        size={"md"}
        children={renderNavigatingToOtherTabWarningBody()}
        footer={renderNavigatingToOtherTabWarningFooter()}
      />
      <ModalView
        show={showModal.showWarningForCategorySelection}
        handleClose={handleCloseModal}
        center={true}
        // showCloseIcon={true}
        title={"Attention"}
        size={"md"}
        children={renderCategorySelectionWarningBody()}
        footer={renderCategorySelectionWarningFooter()}
      />
    </div>
  );
};

export default YouTubeManagementView;
